import {Component, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {Hort360PropertySummary} from '../../../../functions/src/types';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {ApiService} from '../../services/api.service';
import {PropertyService} from '../../services/property.service';
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {LocalStorageService} from "@efaps/ngx-store";

@Component({
  selector: 'app-grower-search',
  templateUrl: './grower-search.component.html',
  styleUrls: ['./grower-search.component.scss']
})
export class GrowerSearchComponent implements OnInit {
  public isSearching = false;
  public searchResults: Hort360PropertySummary[] | null = null;
  private searchEvent = null;
  private lastSearch = null;
  @Input('highlighted') public highlighted: Hort360PropertySummary[] = [];
  @Input('savedSearch') public savedSearch = true;
  @Input('searchTerm') public searchTerm = '';
  @Output('selected') selected = new EventEmitter<Hort360PropertySummary>();

  displayedColumns: string[] = ['id', 'growerDescription', 'nameAddress', 'selected']; // <!-- property -->
  dataSource = null;
  private dataSort = null;
  private dataPaginator = null;
  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSort = sort;
    if (this.dataSort && this.dataSource) {
      this.dataSource.sort = this.dataSort;
    }
  }
  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this.dataPaginator = paginator;
    if (this.dataPaginator && this.dataSource) {
      this.dataSource.paginator = this.dataPaginator;
    }
  }

  constructor(
    private apiService: ApiService,
    private rsDialog: RSDialogService,
    private lsService: LocalStorageService,
    private propertyService: PropertyService
  ) { }

  isHighlighted(property: Hort360PropertySummary) {
    return !this.highlighted || !!this.highlighted.find(p => p.id === property.id);
  }

  public async searchGrowers() {
    this.searchTerm = this.searchTerm.trim();
    if (!this.searchTerm) {
      this.searchResults = null;
      this.dataSource = null;
      this.searchEvent = null;
      this.isSearching = false;
      this.lastSearch = null;
      if (this.savedSearch) {
        this.lsService.remove('propertySearch');
      }
      return;
    } else if (this.lastSearch === this.searchTerm) {
      return;
    }
    const searchEvent = +new Date();
    this.searchEvent = searchEvent;
    this.lastSearch = this.searchTerm;
    if (this.savedSearch) {
      this.lsService.set('propertySearch', this.searchTerm);
    }
    this.searchResults = null;
    try {
      this.isSearching = true;
      const userIds = await this.apiService.seekPropertyIds(this.searchTerm);
      if (this.searchEvent !== searchEvent) {
        return;
      }
      const users = this.propertyService.getPropertySummaries(userIds);
      console.log(users);
      this.searchResults = users.map(u => {
        (u as any).nameAddress = (u.name ? u.name + ', ' : '') + u.address;
        return u;
      });
      this.dataSource = new MatTableDataSource(this.searchResults);
      this.dataSource.sort = this.dataSort;
      this.dataSource.paginator = this.dataPaginator;
      this.isSearching = false;
    } catch (e) {
      console.error(e);
      this.rsDialog.showErrorDialog('Something went wrong. Please try again. ' + e.message);
      this.isSearching = false;
    }
  }

  selectProperty(property: Hort360PropertySummary) {
    this.selected.emit(property);
  }

  ngOnInit(): void {
    this.searchTerm = (this.savedSearch ? this.lsService.get('propertySearch') : '') || '';
    this.searchGrowers();
  }

}
